import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { YearOfSuitDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-year-of-suit',
  templateUrl: './year-of-suit.component.html',
  styleUrls: ['./year-of-suit.component.scss'],
})
export class YearOfSuitComponent implements OnChanges {
  yearofsuitForm: FormGroup;
  yearofsuitFormArray: FormGroup;
  control = new FormControl();
  @Input() yearofsuits: YearOfSuitDto[];
  @Input() routeAnimationsElements: any;
  @Output() yearofsuit = new EventEmitter<YearOfSuitDto[]>();
  @Output() deleteYearOfSuitEvent = new EventEmitter<any>();

  selectedYearOfSuit: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createYearOfSuitForm();
  }

  createYearOfSuitForm() {
    this.yearofsuitForm = this.fb.group({
      YearOfSuitName: ['', Validators.required],
      id: null,
    });
    this.yearofsuitFormArray = this.fb.group({
      YearOfSuits: this.fb.array([]),
    });
    this.setYearOfSuit();
  }

  // method to display yearofsuits
  setYearOfSuit() {
    const control = this.yearofsuitFormArray.controls.YearOfSuits as FormArray;
    this.yearofsuits.forEach((e) => {
      control.push(
        this.fb.group({
          YearOfSuitName: e.YearOfSuitName,
          id: e.id,
        })
      );
    });
  }

  // method to add YearOfSuit
  addYearOfSuit(value: YearOfSuitDto) {
    const control = this.yearofsuitFormArray.controls.YearOfSuits as FormArray;
    control.insert(
      0,
      this.fb.group({
        YearOfSuitName: value.YearOfSuitName,
        id: null,
      })
    );
  }

  selectYearOfSuit(value) {}

  // method to delete yearofsuit from arrary list
  deleteYearOfSuit(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.yearofsuitFormArray.controls
          .YearOfSuits as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.yearofsuits.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.yearofsuits[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: YearOfSuitDto) {
    if (this.yearofsuitForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.yearofsuitFormArray
        .get('YearOfSuits')
        ['controls'][this.selectedIndex].patchValue({
          YearOfSuitName: formValue.YearOfSuitName,
        });
    } else {
      this.addYearOfSuit(formValue);
    }
    this.selectedIndex = null;
    this.yearofsuitForm.reset();
  }

  onEdit(index, value: YearOfSuitDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.yearofsuitForm.patchValue({ YearOfSuitName: value.YearOfSuitName });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.yearofsuitForm.reset();
  }

  onSubmit(formValue: YearOfSuitDto[]) {
    this.yearofsuit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteYearOfSuitEvent.emit(this.filteredDelete);
    }
  }
}
